module.exports = __webpack_public_path__ + "static/media/plus-blue.5e684a5c.svg";